var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    fill: "#141414"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 11.5a1 1 0 0 0-1 1v6a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-12a1 1 0 0 1 1-1h6a1 1 0 1 0 0-2H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-6a1 1 0 0 0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5.5h1.58l-6.29 6.28a1.002 1.002 0 0 0 .325 1.639.999.999 0 0 0 1.095-.219L19 6.92V8.5a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2Z"
  }))));
};
export default SvgLink;